// Package
import { useTranslation } from "react-i18next";

// UI components
import DeleteDeviceModalContainer from "components/DeleteDeviceModalContainer";

const DeleteDeviceModal = (props) => {
  const { modalStatus, changeModalStatus, moveToInventory, deleteFromOrg } =
    props;
  const { t } = useTranslation();

  return (
    <DeleteDeviceModalContainer
      openModal={modalStatus.deleteDevice.status}
      closeModal={() => changeModalStatus("deleteDevice", false)}
      modalWidthType="modal-500px"
      title={t("3cf26cbc8d")}
      description={t("e5cf698770")}
      onMoveToInventory={() => {
        moveToInventory();
      }}
      onDelete={() => {
        deleteFromOrg();
      }}
    />
  );
};

export default DeleteDeviceModal;
